import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../web/components-v2/Theme/theme';

const { colors, typography, common } = THEME;

const numberColumnWidth = 96;
const rowPaddingInline = SPACE[20];

const columnHeader = {
	color: colors.text.light,
	fontSize: typography.fontSizes.xs,
	fontWeight: typography.fontWeights.semibold,
	letterSpacing: '0.04em',
	textTransform: 'uppercase',
} as const;

export const styleSheet = StyleSheet.create({
	header: {
		alignItems: 'center',
		display: 'flex',
		padding: `0 ${rowPaddingInline}px`,
	},
	headerLabel: {
		...columnHeader,
		flex: 1,
	},
	headerNumber: {
		...columnHeader,
		textAlign: 'right',
		width: numberColumnWidth,
	},
	label: {
		flex: 1,
		fontWeight: typography.fontWeights.standard,
	},
	labelSelected: {
		fontWeight: typography.fontWeights.semibold,
	},
	memeCount: {
		fontWeight: typography.fontWeights.semibold,
	},
	number: {
		textAlign: 'right',
		width: numberColumnWidth,
	},
	row: {
		alignItems: 'center',
		background: colors.background.light,
		border: `1px solid ${colors.border.light}`,
		borderRadius: common.borderRadius,
		boxSizing: 'border-box',
		color: colors.text.main,
		cursor: 'pointer',
		display: 'flex',
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.standard,
		height: SPACE[64],
		justifyContent: 'flex-start',
		textAlign: 'left',
		width: '100%',
		padding: `0 ${rowPaddingInline}px`,
		':hover': {
			background: colors.hover.light,
		},
		':focus-visible': {
			outline: `2px solid ${colors.primary.main}`,
			outlineOffset: 2,
		},
	},
	rowSelected: {
		background: colors.primary.light,
		borderColor: colors.primary.main,
		':hover': {
			background: colors.primary.light,
		},
	},
});
